export default __webpack_public_path__ + "static/wallet-c51ea6fd128cb2af0a3482893e0530e4.svg";